// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4218":"32cbc1bf","5555":"32cbc1bf","8959":"32cbc1bf"}[chunkId] + ".chunk.css";
};